import createTheme from './createTheme';
import createBreakpoints from './createBreakpoints';

const breakpoints = createBreakpoints({});

export const theme = {
  breakpoints,
  typography: {
    h6: {
      fontSize: "1.125rem",
      fontWeight: 700
    }
  },
  palette: {
    primary: {
      light: '#6573c3',
      main: '#3f51b5',
      dark: '#2c387e',
    },
    secondary: {
      light: '#e33371',
      main: '#dc004e',
      dark: '#9a0036',
    },
    error: {
      light: '#e57373',
      main: '#f44336',
      dark: '#d32f2f',
    },
    warning: {
      light: '#ffb74d',
      main: '#ff9800',
      dark: '#f57c00',
    },
    info: {
      light: '#64b5f6',
      main: '#2196f3',
      dark: '#1976d2',
    },
    success: {
      light: '#81c784',
      main: '#4caf50',
      dark: '#388e3c',
    },
  },
  components: {
    TopBar: {
      height: 74
    },
    Drawer: {
      collapseWidth: 80,
      defaultWidth: 260
    }
  }
};

export const { createUseStyles, useTheme } = createTheme(theme);
